@if (bio() && bio()!.trim().length > 0) {
  <div
    class="p-5 bg-white dark:bg-neutral-2 rounded-2xl border border-neutral-3 dark:border-neutral-4 shadow-xs text-sm text-neutral-12 leading-relaxed whitespace-pre-line"
  >
    {{ bio() }}
  </div>
} @else {
  <div
    class="p-6 text-center border-2 border-dashed border-neutral-3 dark:border-neutral-4 rounded-2xl bg-white dark:bg-neutral-2 shadow-xs max-w-full"
  >
    <p class="text-xs text-neutral-9 italic whitespace-normal break-words max-w-md mx-auto">
      Aucune présentation rédigée pour le moment. Présentez votre parcours et vos atouts pour inspirer
      confiance aux vendeurs.
    </p>
  </div>
}
